import { useLang } from "../i18n";
import { Reveal, Overline } from "./Reveal";

const chapterImages = {
  "02": "/assets/rooms/double.jpg",
  "03": "https://images.unsplash.com/photo-1690144718430-f96fb6cd9b6c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxzdCUyMHBldGVycyUyMGJhc2lsaWNhJTIwcm9tZXxlbnwwfHx8fDE3ODc3MzE3MDl8MA&ixlib=rb-4.1.0&q=85",
};

const Manifesto = () => {
  const { t } = useLang();
  return (
    <section data-testid="manifesto-section" className="py-28 lg:py-40">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <Reveal>
          <Overline>{t.manifesto.overline}</Overline>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl tracking-tight mt-4 max-w-2xl">
            {t.manifesto.title}
          </h2>
        </Reveal>

        <div className="mt-20 lg:mt-28 space-y-24 lg:space-y-32">
          {t.manifesto.chapters.map((c, i) => (
            <div
              key={c.n}
              className={`grid lg:grid-cols-12 gap-10 items-center ${i % 2 === 1 ? "" : ""}`}
            >
              <Reveal className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2 lg:col-start-7" : ""}`}>
                <span className="font-serif text-7xl lg:text-8xl text-[#D39A2E] leading-none">{c.n}</span>
                <h3 className="font-serif text-2xl md:text-3xl lg:text-4xl mt-6 tracking-tight">{c.title}</h3>
                <p className="mt-6 text-base md:text-lg text-[#14213D]/70 leading-relaxed max-w-lg">{c.text}</p>
              </Reveal>
              {chapterImages[c.n] && (
                <Reveal delay={0.15} className={`lg:col-span-5 ${i % 2 === 1 ? "lg:order-1" : "lg:col-start-8"}`}>
                  <div className="overflow-hidden rounded-[1.5rem] group">
                    <img
                      src={chapterImages[c.n]}
                      alt={c.title}
                      loading="lazy"
                      className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                    />
                  </div>
                </Reveal>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
